import React from 'react'
import getSymbolFromCurrency from 'currency-symbol-map'
import NumberFormat from 'react-number-format'
import { convertCents } from '../../utils'
import { multiDayPricingList } from 'components/utils/multiDayPricingList'
import { 
  findPriceForLoggedInUser,
  findPriceForNonLoggedInUser 
} from 'components/search/layout/searchUtil'  

const BikeProfilePaymentModuleHeader = (props) => {
  const {
    multidayDiscountApplied,
    baseRentalPriceCents,
    baseRentalPriceCurrency,
    dailyPriceCents,
    dailyPriceCurrency,
    addClassName,
    isAuthenticated,
    startDate,
    endDate,
    bikeLowestDailyPriceCents,
    isTripTaken,
    bikeData,
    multiDayPricingList
  } = props

  const bookNowHeaderClass = props.multidayDiscountApplied
    ? 'bike-profile-book-now-header multi-applied ' + addClassName
    : 'bike-profile-book-now-header ' + addClassName

  function PriceHeaderForNonLoggedInUser() {
    return (
      <React.Fragment>
        <div className="price-num-multiday-crossout">
          <NumberFormat
            defaultValue={convertCents(baseRentalPriceCents)}
            decimalScale={0}
            displayType={'text'}
            thousandSeparator={true}
            prefix={getSymbolFromCurrency(baseRentalPriceCurrency)}
          />
            /day
        </div>
        <div className="price-num-wrapper">
          <span className="price-num">
            <NumberFormat
              value={convertCents(findPriceForNonLoggedInUser(
                baseRentalPriceCents, startDate, endDate
              ))}
              decimalScale={0}
              displayType={'text'}
              thousandSeparator={true}
              prefix={getSymbolFromCurrency(dailyPriceCurrency)}
            />
          </span>
          <h1 className="plus-fees mt-3"> /day + Fees</h1>
        </div>
      </React.Fragment>
    )
  }

  function LoggedInWithTripLength() {
    return (
      <React.Fragment>
        {multidayDiscountApplied &&
          <div className="price-num-multiday-crossout">
            <NumberFormat
              defaultValue={convertCents(baseRentalPriceCents)}
              decimalScale={0}
              displayType={'text'}
              thousandSeparator={true}
              prefix={getSymbolFromCurrency(baseRentalPriceCurrency)}
            />
              /day
          </div>
        }
        <div className="price-num-wrapper">
          <span className="price-num">
            <NumberFormat
              value={convertCents(findPriceForLoggedInUser(
                bikeData.bike_info, startDate, endDate, multiDayPricingList, isTripTaken
              ))}
              decimalScale={0}
              displayType={'text'}
              thousandSeparator={true}
              prefix={getSymbolFromCurrency(dailyPriceCurrency)}
            />
          </span>
          <h1 className="plus-fees mt-3"> /day + Fees</h1>
        </div>
      </React.Fragment>
    )
  }

  function LoggedInWithNoTripLength() {
    return (
      <React.Fragment>
        <div className="price-num-multiday-crossout">
          <NumberFormat
            defaultValue={convertCents(baseRentalPriceCents)}
            decimalScale={0}
            displayType={'text'}
            thousandSeparator={true}
            prefix={getSymbolFromCurrency(baseRentalPriceCurrency)}
          />
            /day
        </div>
        <div className="price-num-wrapper">
          <span className="price-num">
            <NumberFormat
              value={convertCents(findPriceForLoggedInUser(
                bikeData.bike_info, startDate, endDate, multiDayPricingList, isTripTaken
              ))}
              decimalScale={0}
              displayType={'text'}
              thousandSeparator={true}
              prefix={getSymbolFromCurrency(dailyPriceCurrency)}
            />
          </span>
          <h1 className="plus-fees mt-3"> /day + Fees</h1>
        </div>
      </React.Fragment>
    )
  }

  return (
    <div className={bookNowHeaderClass}>
      {isAuthenticated  && isTripTaken && (
        <LoggedInWithTripLength />
      )}
      {isAuthenticated && !isTripTaken && (
        <LoggedInWithNoTripLength />
      )}
      {!isAuthenticated && (
        <PriceHeaderForNonLoggedInUser />
      )}
    </div>
  )
}

export default BikeProfilePaymentModuleHeader
